import { fetchAPI } from "../../redux/api";

const restaurantId = () => {
  const info = JSON.parse(localStorage.getItem("admin_token_info") || "{}");
  if (!info.restaurantId) throw new Error("Restaurant session is missing. Please log in again.");
  return info.restaurantId;
};

const read = async (response) => {
  if (response.ok) return response.status === 204 ? null : response.json();
  let message = "Request failed. Please try again.";
  try {
    const body = await response.json();
    message = body?.errors?.[""]?.[0] || body?.title || body?.message || message;
  } catch (_) {}
  const error = new Error(message);
  error.status = response.status;
  throw error;
};

export const getTakeawaySettings = async () => read(await fetchAPI(`TakeawaySettings/${restaurantId()}`));
export const saveTakeawaySettings = async (settings) =>
  read(await fetchAPI(`TakeawaySettings/${restaurantId()}`, settings, "PUT"));
export const getTakeawayQrCode = async (publicUrl) => {
  const response = await fetchAPI(`TakeawaySettings/${restaurantId()}/qr-code`, publicUrl, "POST");
  if (!response.ok) await read(response);
  return response.blob();
};
export const getTakeawayOrders = async (view = "live") =>
  read(await fetchAPI(`TakeawayOrders/${restaurantId()}?view=${encodeURIComponent(view)}`));
export const createTakeawayOrder = async (order) =>
  read(await fetchAPI(`TakeawayOrders/${restaurantId()}`, order, "POST"));
export const updateTakeawayStatus = async (orderId, status) =>
  read(await fetchAPI(`TakeawayOrders/${restaurantId()}/${orderId}/status`, { status }, "PATCH"));
export const getTakeawayBill = async (orderId) => {
  const response = await fetchAPI(`TakeawayOrders/${restaurantId()}/${orderId}/bill`);
  if (response.status === 404) return null;
  return read(response);
};
export const createTakeawayBill = async (orderId, request) =>
  read(await fetchAPI(`TakeawayOrders/${restaurantId()}/${orderId}/bill`, request, "POST"));
export const settleTakeawayBill = async (orderId, request) =>
  read(await fetchAPI(`TakeawayOrders/${restaurantId()}/${orderId}/bill/payment`, request, "PATCH"));
